"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingContent = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var UserSettingsAccount_1 = require("./view/UserSettingsAccount");
var PrivacyAndSecurity_1 = require("./view/PrivacyAndSecurity");
var SchemeAndPayment_1 = require("./view/SchemeAndPayment");
var Language_1 = require("./view/Language");
var Theme_1 = require("./view/Theme");
var Message_1 = require("./view/Message");
var ShortcutKey_1 = require("./view/ShortcutKey");
var MarkdownShortcutkey_1 = require("./view/MarkdownShortcutkey");
var UpdateLog_1 = require("./view/UpdateLog");
var ConnectWithUs_1 = require("./view/ConnectWithUs");
function SettingContent() {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(react_router_dom_1.Switch, null,
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/userSettingsAccount" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(UserSettingsAccount_1.UserSettingsAccount, null))),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/privacyandsecurity" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(PrivacyAndSecurity_1.PrivacyAndSecurity, null))),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/schemeandpayment" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(SchemeAndPayment_1.SchemeAndPayment, null))),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/language" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Language_1.Language, null))),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/theme" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Theme_1.Theme, null))),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/message" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Message_1.Message, null))),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/shortcutkey" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(ShortcutKey_1.ShortcutKey, null))),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/markdownkey" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(MarkdownShortcutkey_1.MarkdownShortcutkey, null))),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/updatelog" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(UpdateLog_1.UpdateLog, null))),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/connectwithus" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(ConnectWithUs_1.ConnectWithUs, null))),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/logout" },
                react_1.default.createElement("div", null, "router")))));
}
exports.SettingContent = SettingContent;
//# sourceMappingURL=index.js.map